/* Albury Downs audit fixes, 2026-11-04. 2.6 sticky mobile bar.
   Shows once the Notify me / Add to cart form has scrolled off the top of the screen.
   Hides again when the form or the footer is on screen. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  ready(function () {
    var bar = document.querySelector('[data-ad-sticky-bar]');
    if (!bar) { return; }
    document.body.appendChild(bar);
    var btn = bar.querySelector('button');
    var target = document.querySelector('.back-in-stock-form') || document.querySelector('form[action*="/cart/add"]');
    var footer = document.querySelector('.site-footer');
    if (!target) { return; }
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var t = target.getBoundingClientRect();
      var pastTarget = t.bottom < 0;
      var footerVisible = false;
      if (footer) { var f = footer.getBoundingClientRect(); footerVisible = f.top < vh; }
      var hide = !pastTarget || footerVisible;
      bar.classList.toggle('is-hidden', hide);
      bar.setAttribute('aria-hidden', hide ? 'true' : 'false');
      if (btn) { btn.tabIndex = hide ? -1 : 0; }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
    if (btn) {
      btn.addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var field = target.querySelector('input[type="email"]') || target.querySelector('button[type="submit"]');
        if (field) { setTimeout(function () { try { field.focus({ preventScroll: true }); } catch (err) { field.focus(); } }, 450); }
      });
    }
  });
})();
